import makeStyles from '@mui/styles/makeStyles'

const bp = 'sm'

const useStyles = makeStyles(theme => ({
  name: {
    display: 'flex',
    borderBottom: `0.0625rem solid ${theme.palette.border}`,
    padding: '1rem',

    [theme.breakpoints.down(bp)]: {
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: '2rem'
    }
  },

  avatar: {
    position: 'relative',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: '100%',
    width: '5rem',
    height: '5rem',
    cursor: 'pointer'
  },

  input: {
    flexGrow: 1,
    outline: 'none',
    border: 'none',
    marginLeft: '2rem',
    fontSize: theme.size.xl,
    opacity: '0.7',

    [theme.breakpoints.down(bp)]: {
      marginLeft: '0',
      marginTop: '1.5rem',
      textAlign: 'center'
    }
  },

  camera: {
    height: '2rem',
    width: '2rem',
    background: '#ADC2CC',
    borderRadius: '100%',
    padding: '1.5rem',
    color: 'white',
    cursor: 'pointer'
  },

  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },

  clearIcon: {
    padding: '0.25rem',
    fontSize: theme.size.lg,
    borderRadius: '100%',
    backgroundColor: 'white',
    border: '1px solid rgba(230, 234, 236, 0.9)',
    position: 'absolute',
    top: '-6px',
    right: '-6px',
    cursor: 'pointer',
    transition: 'background-color 250ms',

    '&:hover': {
      backgroundColor: '#d3d3d37f'
    }
  },

  cropIcon: {
    padding: '0.25rem',
    fontSize: theme.size.lg,
    borderRadius: '100%',
    backgroundColor: 'white',
    border: '1px solid rgba(230, 234, 236, 0.9)',
    position: 'absolute',
    bottom: '-6px',
    right: '-6px',
    cursor: 'pointer',
    transition: 'background-color 250ms',

    '&:hover': {
      backgroundColor: '#d3d3d37f'
    }
  }
}))

export default useStyles
